<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  props: {
    personalAccessToken: Object
  },

  data() {
    return {
      editName: false,
      editDescription: false,
      personalAccessTokenUpdating: false,
      name: this.personalAccessToken.name,
      description: this.personalAccessToken.description
    }
  },

  computed: {
    ...mapState({
      userPersonalAccessTokensRoles: state =>
        state.personalAccessTokens.userPersonalAccessTokensRoles
    })
  },

  watch: {
    personalAccessToken() {
      this.name = this.personalAccessToken.name
      this.description = this.personalAccessToken.description
    }
  },

  methods: {
    async setName() {
      this.personalAccessTokenUpdating = true
      this.editName = false
      try {
        await this.$store.dispatch('updatePersonalAccessToken', {
          body: { name: this.name },
          hexId: this.personalAccessToken.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Personal Access Token renamed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Personal Access Token rename Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetName()
      }
      this.personalAccessTokenUpdating = false
    },

    resetName() {
      this.editName = false
      this.name = this.personalAccessToken.name
    },

    async setDescription() {
      this.personalAccessTokenUpdating = true
      this.editDescription = false
      try {
        await this.$store.dispatch('updatePersonalAccessToken', {
          body: { description: this.description },
          hexId: this.personalAccessToken.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Personal Access Token description updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'PersonalAccessToken description update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetDescription()
      }
      this.personalAccessTokenUpdating = false
    },

    resetDescription() {
      this.editDescription = false
      this.description = this.personalAccessToken.description
    }
  }
}
</script>

<template>
  <v-card class="beez-card">
    <v-toolbar dense card class="elevation-2">
      <v-toolbar-title class="body-2 beez-bold "
        >{{ personalAccessToken.name }}
      </v-toolbar-title>
    </v-toolbar>
    <v-progress-linear
      indeterminate
      color="accent"
      class="ma-0"
      height="5"
      :active="personalAccessTokenUpdating"
    />
    <div class="pa-3">
      <v-text-field
        :outline="$vuetify.dark"
        color="secondary"
        label="Name"
        v-model="name"
        :readonly="!editName"
      >
        <template slot="append">
          <template v-if="editName">
            <v-icon @click="resetName">clear</v-icon>
            <v-icon @click="setName">save</v-icon>
          </template>
          <v-icon v-else @click="editName = true">edit</v-icon>
        </template>
      </v-text-field>
      <v-text-field
        :outline="$vuetify.dark"
        color="secondary"
        label="Description"
        v-model="description"
        :readonly="!editDescription"
        :rows="1"
        auto-grow
        no-resize
      >
        <template slot="append">
          <template v-if="editDescription">
            <v-icon @click="resetDescription">clear</v-icon>
            <v-icon @click="setDescription">save</v-icon>
          </template>
          <v-icon v-else @click="editDescription = true">edit</v-icon>
        </template>
      </v-text-field>
    </div>
  </v-card>
</template>
